// Please keep alphabetized
export enum IconName {
  AccessLogo,
  Add,
  AppForOfficeLogo,
  AppIconDefault,
  apps,
  ArrowDownRight8,
  ArrowUpRight8,
  Attach,
  Back,
  BackToWindow,
  Blocked2,
  Breadcrumb,
  Broom,
  Calendar,
  Cancel,
  CaretDownSolid8,
  Chart,
  CheckboxComposite,
  CheckMark,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CirclePlus,
  CircleRing,
  ClearFilter,
  Clock,
  Contact,
  Copy,
  CustomIcon,
  Delete,
  Documentation,
  DocumentSet,
  DoubleChevronDown,
  DoubleChevronLeft,
  DoubleChevronUp,
  Down,
  Download,
  DRM,
  Edit,
  EditNote,
  Embed,
  ErrorBadge,
  Event,
  ExcelLogo,
  FabricAssetLibrary,
  FabricDataConnectionLibrary,
  FabricDocLibrary,
  FabricFolder,
  FabricFolderFill,
  FabricFolderSearch,
  FabricFormLibrary,
  FabricFormLibraryMirrored,
  FabricMovetoFolder,
  FabricNewFolder,
  FabricOpenFolderHorizontal,
  FabricPictureLibrary,
  FabricPublicFolder,
  FabricReportLibrary,
  FabricReportLibraryMirrored,
  FabricSyncFolder,
  FabricUnsyncFolder,
  FavoriteStar,
  FavoriteStarFill,
  Filter,
  FlickLeft,
  Flow,
  Folder,
  Forward,
  FullCircleMask,
  FullScreen,
  Glimmer,
  GlobalNavButton,
  Globe,
  GripperTool,
  Group,
  GroupedAscending,
  GroupedDescending,
  GroupedList,
  Heart,
  HeartFill,
  Home,
  IncidentTriangle,
  Info,
  Info2,
  LargeGrid,
  Lightbulb,
  LightningBolt,
  Link,
  List,
  Lock,
  Mail,
  Message,
  MiniContract,
  MiniExpand,
  More,
  move,
  MoveToFolder,
  MusicInCollection,
  MusicInCollectionFill,
  Mute,
  new,
  NewFolder,
  OfficeLogo,
  OfficeVideoLogo,
  OneDrive,
  OneDriveAdd,
  OneNoteLogo,
  Org,
  OutlookLogo,
  Page,
  Pause,
  PDF,
  People,
  PeopleAdd,
  Phone,
  Photo2Add,
  Photo2Remove,
  Picture,
  Pin,
  Pinned,
  Play,
  PowerApps2Logo,
  PowerPointLogo,
  Print,
  progress,
  QuickNote,
  ReadingMode,
  Refresh,
  RemoveFilter,
  RemoveLink,
  RevToggleKey,
  Ringer,
  RingerSilent,
  rotate,
  Save,
  Search,
  Settings,
  Share,
  SharepointLogo,
  SkypeCheck,
  SkypeClock,
  SkypeMinus,
  SortDown,
  SortLines,
  SortUp,
  StatusErrorFull,
  SwayLogo,
  Sync,
  SyncToPC,
  Tag,
  Tasks,
  textBox,
  Tiles,
  Undo,
  Unpin,
  Up,
  Upload,
  View,
  ViewAll,
  VisioLogo,
  Volume1,
  Volume2,
  Volume3,
  VolumeDisabled,
  Waffle,
  Warning,
  WordLogo,
  WorkFlow,
  ZoomIn
}